import { createStyles } from '@asuikit/styles';

export default createStyles(() => ({
  close: {
    marginLeft: 'auto',
    marginRight: 0,
    border: '1px solid var(--asuikit-color-line-3)',
  },
}));
